export default {
  path: '/sectors',
  name: 'sectors',
  component: () => import('../components/sector/Layout'),
  redirect: { name: 'SectorList' },
  meta: {
    breadcrumb: 'sector.sectors',
  },
  children: [
    {
      name: 'SectorList',
      path: '',
      component: () => import('../views/sector/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'SectorCreate',
      path: 'new',
      component: () => import('../views/sector/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'SectorUpdate',
      path: ':id/edit',
      component: () => import('../views/sector/Update'),
      meta: {
        breadcrumb: 'sector.sector',
      },
    },
    {
      name: 'SectorShow',
      path: ':id',
      component: () => import('../views/sector/Show'),
      meta: {
        breadcrumb: 'sector.sector',
      },
    }
  ]
};
